import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useSuggestedProfiles } from "@domain/user/hooks";
import { ArrowNavigator } from "@ui/components/arrowNavigator";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Tertiary } from "@ui/components/containers/textBlocks";
import { Row } from "@ui/components/layout";
import { SuggestedProfileThumbnail } from "@ui/components/profile/suggestedUserThumbnail";
import { gap } from "@ui/styles/utils";

type ProfileSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const ProfileSuggestions: React.FC<ProfileSuggestionsProps> = ({ ...htmlProps }) => {
	const { result: profiles, loading } = useSuggestedProfiles(10);
	const filteredProfiles = (profiles ?? []).filter((p) => !p.followedByMeSince);
	const [currentIndex, setIndex] = useState(0);
	const displayedProfile = filteredProfiles[currentIndex];

	useEffect(() => {
		if (filteredProfiles.length > 0 && currentIndex >= filteredProfiles.length) {
			setIndex(filteredProfiles.length - 1);
		}
	}, [filteredProfiles.length]);

	return (
		<Container {...htmlProps}>
			<Row gap={10} align="center" justify="space-between">
				<PrimaryMedium>{I18n.t("profile.suggest.title")}</PrimaryMedium>
				<StyledArrowNavigator
					small
					previous={() => setIndex((i) => (i - 1 + filteredProfiles.length) % filteredProfiles.length)}
					next={() => setIndex((i) => (i + 1) % filteredProfiles.length)}
				/>
			</Row>
			{loading ? (
				<ClipLoader />
			) : displayedProfile ? (
				<SuggestedProfileThumbnail profile={displayedProfile} />
			) : (
				<Tertiary>{I18n.t("profile.suggest.empty")}</Tertiary>
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(16)};
`;

const StyledArrowNavigator = styled(ArrowNavigator)`
	width: 70px;
`;
